// Import necessary modules and libraries
import React, { createContext, useContext, useState } from "react";
import { addDays } from "date-fns";
import { useDispatch, useSelector } from "react-redux";
import { useGlobalContext } from "./userContext";
import { Base_Url } from "../../component/Services/ApiFile";
import {
  addFilterData,
  addFilterSelected,
  addMarketList
} from "../store/reducers/brandAnalysis";

// Create a new context
const dashboardContext = createContext();

// Create a custom hook for using the context
export const useDashboardContext = () => useContext(dashboardContext);

// Create a provider component
export const DashboardContextProvider = ({ children }) => {
  const globalContext = useGlobalContext();
  const [product, setProduct] = useState();
  const [productList, setProductList] = useState([]);
  const [marketsList, setMarketsList] = useState([]);
  const [graphData, setGraphData] = useState([]);
  const [overviewData, setOverviewData] = useState();
  const [marketIcons, setMarketIcons] = useState([]);
  const [marketPlaceData, setMarketPlaceData] = useState();
  const [marketTableData, setMarketTableData] = useState();
  const [variantsSelected, setVariantsSelected] = useState([]);
  const [topReviewsData, setTopReviewsData] = useState([]);
  const [variantData, setVariantData] = useState();
  const [bsrDownloadData, setBsrDownloadData] = useState([]);
  const [productTrend, setProductTrend] = useState();
  const [showModal, setShowModal] = useState(true);
  const [market, setMarket] = useState([]);
  const [range, setRange] = useState([
    {
      startDate: new Date(),
      endDate: addDays(new Date(), 7),
      key: "selection"
    }
  ]);
  const [negativeData, setNegativeData] = useState([]);
  const [negativeMasterIssueDataKapiva, setNegativeMasterIssueDataKapiva] =
    useState([]);
  const [staticChangingData, setStaticChangingData] = useState();
  const [changingdata, setchangingData] = useState();
  const [complainTableData, setComplainTableData] = useState([]);
  const [brandSummary, setBrandSummary] = useState();
  const [weeks, setWeeks] = useState([]);
  const [allReviews, setAllReviews] = useState();
  const [showTable, setShowTable] = useState(false);
  const [aggregation, setAggregation] = useState("weekly");
  const [masterTagsSelected, setMasterTagsSelected] = useState([]);
  const [masterIssueHeaderData, setMasterIssueHeaderData] = useState();
  const [ProductEdit, setProductEdit] = useState();
  const [negativeDownload, setNegativeDownload] = useState();
  const [dataLoaded, setDataLoaded] = useState(false);
  const [npsLoading, setNpsLoading] = useState(false);
  const [overviewLoading, setOverviewLoading] = useState(false);
  const [reviewLoading, setReviewLoading] = useState(false);
  const [variantLoading, setVariantLoading] = useState(false);
  const [positiveData, setPositiveData] = useState();
  const [positiveDownload, setPositiveDownload] = useState();
  const [months, setMonth] = useState();
  const [monthlyNegativeData, setmonthlyNegativeData] = useState();
  const [monthlyPositiveData, setmonthlyPositiveData] = useState();
  const [categoryList, setCategoryList] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [tabs, setTabs] = useState();
  const [dashboardLoading, setDashboardLoading] = useState(false);
  const [competitorProduct, setCompetitorProduct] = useState([]); //
  const [userFilter, setUserFilter] = useState();
  const [allProductList, setAllProductList] = useState([]);
  const [filterData, setFilterData] = useState();
  const [ratingsMarketTableData, setRatingsMarketTableData] = useState();
  const dispatch = useDispatch();
  // Fetch User Data
  const brands = ['3 gnar', 'adj - american dj', 'algreen products', 'all seasons',
    'american fuel tank', 'american telecast products', 'apache', 'aqua lily pad',
    'aterian group', 'auto floor guard', 'baby trend', 'bac industries', 'banzai',
    'barbour international', 'bear mountain bbq', 'best ride on cars',
    'bestier - marketplace fulfillment', 'bestway', 'bestway network technology',
    'boost oxygen', 'boss audio systems', 'brock supply', 'brower', 'brut worm farms',
    'bumbo distribution usa', 'c&s holmes', 'cabana filters', 'camco manufacturing',
    'caravan global', 'champion packaging and distribution', 'chapin manufacturing',
    'chargepoint', 'chauvet', 'cinderella - hayward whole goods', 'cinderella - main access',
    'cinderella - trevi', 'cinderella - unicel', 'cinderella - vinyl works', 'clam corp',
    'cookinpellets', 'curtis international', 'decoro home', 'delta electronics', 'deltess corp',
    'design ideas', 'devoko - marketplace fulfillment', 'dewitt company', 'disc-o-bed',
    'duraflame', 'dura-trel', 'duravent', 'dynamic motion dba larktale', 'dynasty mattress',
    'entrepreneur venture capital', 'ewc', 'f2c global limited - marketplace fulfillment',
    'farm innovators', 'fastpak systems', 'fcmp outdoor', 'findlay machine & tool',
    'fisher-price brands', 'fogatti', 'gaia enterprises', 'general marketing solutions',
    'genesis archery', 'get busy playin', 'gibson overseas', 'glass kings distribution',
    'goba sports', 'golden designs', 'goldwood', 'good ideas', 'gracious living corp',
    'graham-field', 'green touch industries', 'grimco', 'gsm', 'gulf coast sand',
    'haden appliances', 'hailo us', 'hauck usa', 'hc companies', 'hedstrom fitness',
    'highland trading', 'hit run steal', 'hms mfg', 'hodedah import', 'holahatha',
    'holyn enterprises', 'hurricane fans', 'hurricane ventures', 'hydrofarm', 'i2poly',
    'impex', 'ina international', 'innovative enterprise', 'international leisure products - swimline',
    'intex', 'iris usa', 'jaxpety corp', 'jewett cameron', 'jiangsu jilong sport and leisure',
    'john boos & co', 'jonas corporation', 'juggernaut storage', 'jumpflex usa', 'jumpsport',
    'kathys universe limited', 'keter us', 'keter us - marketplace fulfillment', 'kids2 kids',
    'kms - marketplace fulfillment', 'kti hydraulics', 'la la land', 'lafuma america', 'lasko products',
    'lifetime products', 'ltl wholesale', 'mac sports', 'maroi wicker sl', 'mattel', 'maven lane',
    'maxxsonics', 'mc appliance', 'meco corporation', 'medal sports', 'medion ag', 'michigan peat',
    'miller manufacturing', 'mitek - mtx', 'morrell manufacturing', 'motion water sports', 'motis',
    'mrcool', 'mscki', 'multy home lp', 'muse home', 'national presto industries',
    'neosheng commerce', 'newell brands distribution', 'newell brands distribution - rubbermaid',
    'ningbo suntime garden furniture', 'north atlantic imports', 'novion',
    'obsidian industries', 'odyssey innovative designs', 'oneida air systems', 'oriental recreational products',
    'origami group', 'packaging corporation', 'palmetto vermiculite', 'panacea products', 'paricon',
    'pinnacle climate technologies', 'pj chonburi parawood', 'plantonix', 'polygroup evergreen limited',
    'polygroup trading limited', 'prism fitness', 'productworks', 'q power', 'qiduo innovation',
    'radio flyer', 'ram quality products', 'razor', 'really useful box', 'recpro', 'reeves international',
    'rev a shelf', 'revoace griddle', 'rhythm healthcare', 'rich dad', 'rj thomas mfg',
    'robert bosch tool corporation', 'royalbaby cycle beijing', 'rugged ranch products', 'saftron',
    'samsonite', 'scepter manufacturing', 'sengoku la', 'shanghai sishun e-commerce', 'shark ninja',
    'shelf reliance', 'shelterlogic', 'sienhua group', 'skb cases', 'sleepgram', 'sohnen enterprises',
    'solar sun rings', 'sound around', 'spin master', 'spyra gmbh', 'stamina products', 'sterilite',
    'suncast', 'supply chain sources lifesmart', 'swim ways - kelsyus - import', 'swimline corp',
    'tastemakers', 'taylor technologies', 'the ames company att southern', 'the ames company closetmaid',
    'tipke manufacturing', 'titan post drivers', 'toughbuilt industries', 'trc recreation',
    'tri global enterprises', 'tricam industries', 'true play', 'ultimate sack', 'ultra soap international',
    'union grand imp & exp', 'united solutions', 'united states stove company', 'uriah products', 'us silica company',
    'veritiv', 'vevor - marketplace fulfillment', 'vuly usa operations corp', 'w.c. redmon', 'wall control', 'watkins wellness',
    'wood products international', 'xdp recreation', 'yakima products', 'yiwu guoyou', 'yj usa', 'zorin int sp zoo',
    'hkc-us', 'living essentials', 'the scotts company','all things cedar', 'gns sales', 'shaw international trading','coaster company',
  'test account','truride tech', 'pvp industries','hurav','homecare products','propeller brands','kitchen elite','kimpex a/s',
  'dolu oyuncak san ve tic','heynemo','cozayh']
  
  
  const fetchUserData = async () => {
    try {
      if (!brands.includes(globalContext.userData.username.toLowerCase())) {
      globalContext.backdropOpen();
      }
      setDashboardLoading(true);
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${globalContext.userData.token}`
        }
      };
      const response = await fetch(
        Base_Url + "/info/get-all-user-data",
        requestOptions
      );

      const userData = await response.json();
      const ratings = (item, productData) => {
        const product = productData?.filter(product => {
          return product?.master_product_id === item?.id;
        })?.[0];

        return { ...item, ratings: product?.["Average Rating"][1] };
      };
      let temp = [];
      if (userData) {
        const processProductList = (productList, isCompetitor) => {
          return productList.reduce((acc, item) => {
            const masterProduct = item?.master_product;
            if (!(masterProduct?.is_competitor_product !== isCompetitor)) {
              const variants = [...(item.variants || []), masterProduct];
              const data = {
                label: masterProduct.product_name,
                data: masterProduct,
                img: masterProduct.image_url,
                id: masterProduct.master_product_id,
                variant: variants
              };
              acc.push(data);
            }
            return acc;
          }, []);
        };

        const filtered = processProductList(
          userData?.product_list || [],
          false
        );
        const filteredCompetitor = processProductList(
          userData?.product_list || [],
          true
        );

        setCompetitorProduct(filteredCompetitor);

        let requestData = {
          marketplaces: [],
          filters: {},
          marketList: userData?.market_list,
          productList: filtered,
          username: globalContext.userData.username
        };
        if (!brands.includes(globalContext.userData.username.toLowerCase())) {
          try {
            let response = await fetch(
              Base_Url + "/table/get-brand-page-nps-data",
              {
                method: "POST",
                headers: new Headers({
                  "Content-Type": "application/json",
                  Authorization: `Token ${globalContext.userData.token}`
                }),
                body: JSON.stringify(requestData)
              }
            );

            const brandPageNpsData = await response.json();

            if (!brandPageNpsData) return;
            const [tempdata1, tempData] = brandPageNpsData?.result;
            console.log(tempData);
            if (brandPageNpsData?.result) {
              const productData = tempData?.Reviews?.monthly;
              const productListArray = [];
              filtered?.forEach(item1 => {
                productListArray?.push(ratings(item1, productData));
              });
              setProductList(
                productListArray?.sort((item1, item2) => {
                  return item2?.["ratings"] - item1["ratings"];
                })
              );
            }
          } catch (error) {
            console.error(error);
          }
        }

        setProductEdit(filtered);
        setCategoryList(userData.categories);
        setMarketsList(
          userData?.market_list
            ?.slice()
            ?.sort((a, b) => a.market_name.localeCompare(b.market_name))
        );
        dispatch(addMarketList(userData.market_list));
        setTabs(userData.tab_list);
        dispatch(addFilterData(userData?.user_filters));
        setUserFilter(userData?.user_filters);
        setAllProductList([...filtered, ...filteredCompetitor]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setDashboardLoading(false);
      if (!brands.includes(globalContext.userData.username.toLowerCase())) {
      globalContext.backdropClose();
      }
    }
  };

  const handleClose = () => {
    setShowModal(false);
  };

  const handleModalOpen = () => {
    setShowModal(true);
  };
  // State from Redux (you can replace this with your actual Redux setup)
  const state = useSelector(state => state.TrendAnalysis);
  const contextCleanup = () => {
    const initialState = {
      product: undefined,
      productList: [],
      marketsList: [],
      overviewData: undefined,
      marketIcons: [],
      marketPlaceData: undefined,
      marketTableData: undefined,
      variantsSelected: [],
      topReviewsData: [],
      variantData: undefined,
      productTrend: undefined,
      market: [],
      range: [
        {
          startDate: new Date(),
          endDate: addDays(new Date(), 7),
          key: "selection"
        }
      ],
      negativeData: [],
      negativeMasterIssueDataKapiva: [],
      staticChangingData: undefined,
      changingdata: undefined,
      complainTableData: [],
      brandSummary: undefined,
      weeks: [],
      allReviews: undefined,
      showTable: false,
      aggregation: "weekly",
      masterTagsSelected: [],
      masterIssueHeaderData: undefined,
      ProductEdit: undefined,
      negativeDownload: undefined,
      dataLoaded: false,
      npsLoading: false,
      overviewLoading: false,
      reviewLoading: false,
      variantLoading: false,
      positiveData: undefined,
      positiveDownload: undefined,
      months: undefined,
      monthlyNegativeData: undefined,
      monthlyPositiveData: undefined,
      categoryList: [],
      selectedCategory: null
    };

    setProduct(initialState.product);
    setProductList(initialState.productList);
    setMarketsList(initialState.marketsList);
    setOverviewData(initialState.overviewData);
    setMarketIcons(initialState.marketIcons);
    setMarketPlaceData(initialState.marketPlaceData);
    setMarketTableData(initialState.marketTableData);
    setVariantsSelected(initialState.variantsSelected);
    setTopReviewsData(initialState.topReviewsData);
    setVariantData(initialState.variantData);
    setProductTrend(initialState.productTrend);
    setMarket(initialState.market);
    setRange(initialState.range);
    setNegativeData(initialState.negativeData);
    setNegativeMasterIssueDataKapiva(
      initialState.negativeMasterIssueDataKapiva
    );
    setStaticChangingData(initialState.staticChangingData);
    setchangingData(initialState.changingdata);
    setComplainTableData(initialState.complainTableData);
    setBrandSummary(initialState.brandSummary);
    setWeeks(initialState.weeks);
    setAllReviews(initialState.allReviews);
    setShowTable(initialState.showTable);
    setAggregation(initialState.aggregation);
    setMasterTagsSelected(initialState.masterTagsSelected);
    setMasterIssueHeaderData(initialState.masterIssueHeaderData);
    setProductEdit(initialState.ProductEdit);
    setNegativeDownload(initialState.negativeDownload);
    setDataLoaded(initialState.dataLoaded);
    setNpsLoading(initialState.npsLoading);
    setOverviewLoading(initialState.overviewLoading);
    setReviewLoading(initialState.reviewLoading);
    setVariantLoading(initialState.variantLoading);
    setPositiveData(initialState.positiveData);
    setPositiveDownload(initialState.positiveDownload);
    setMonth(initialState.months);
    setmonthlyNegativeData(initialState.monthlyNegativeData);
    setmonthlyPositiveData(initialState.monthlyPositiveData);
    setCategoryList(initialState.categoryList);
    setSelectedCategory(initialState.selectedCategory);
    setTabs();
    setUserFilter();
  };

  // Create a context value object with all your state variables and functions
  const contextValue = {
    product,
    productList,
    marketsList,
    overviewData,
    marketIcons,
    marketPlaceData,
    marketTableData,
    variantsSelected,
    topReviewsData,
    variantData,
    bsrDownloadData,
    setBsrDownloadData,
    market,
    range,
    negativeData,
    negativeMasterIssueDataKapiva,
    weeks,
    allReviews,
    showTable,
    aggregation,
    masterTagsSelected,
    masterIssueHeaderData,
    ProductEdit,
    graphData,
    setGraphData,
    setProductEdit,
    setProductList,
    marketsList,
    setMarketsList,
    setTopReviewsData,
    setOverviewData,
    setMarketPlaceData,
    setMarketTableData,
    setAllReviews,
    setDataLoaded,
    reviewLoading,
    npsLoading,
    overviewLoading,
    setNpsLoading,
    setMarket,
    setProduct,
    setOverviewLoading,
    setMarketIcons,
    setReviewLoading,
    setVariantLoading,
    setNegativeData,
    negativeDownload,
    dataLoaded,
    overviewLoading,
    variantLoading,
    positiveData,
    positiveDownload,
    months,
    monthlyNegativeData,
    monthlyPositiveData,
    setNegativeMasterIssueDataKapiva,
    setShowTable,
    setMasterIssueHeaderData,
    setVariantData,
    setVariantsSelected,
    setWeeks,
    setMonth,
    setNegativeDownload,
    setPositiveData,
    setPositiveDownload,
    setmonthlyNegativeData,
    setmonthlyPositiveData,
    productTrend,
    setProductTrend,
    setCategoryList,
    competitorProduct,
    categoryList,
    selectedCategory,
    setSelectedCategory,
    brandSummary,
    setBrandSummary,
    setchangingData,
    changingdata,
    setStaticChangingData,
    staticChangingData,
    complainTableData,
    setComplainTableData,
    contextCleanup,
    fetchUserData,
    userFilter,
    tabs,
    dashboardLoading,
    allProductList,
    filterData,
    setFilterData,
    ratingsMarketTableData,
    setRatingsMarketTableData,
    handleClose,
    showModal,
    handleModalOpen
  };

  return (
    <dashboardContext.Provider value={contextValue}>
      {children}
    </dashboardContext.Provider>
  );
};
